import { environment } from '../../environments/environment';
import { Component } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent {
  siteUrl = environment.siteUrl;
}
